import { useQuery } from '@tanstack/react-query';

import type { WeightUnitCode } from '@nucleus-commerce/core';

import { organizationSettingsQueryOptions } from '@/features/organization-settings';

/**
 * Where the weight picker starts. Staff without `settings.read` get a 403 here, which must not
 * replace the product page with not-permitted, so the query never throws and falls back to grams.
 */
export function useDefaultWeightUnit(): WeightUnitCode {
  const query = useQuery({ ...organizationSettingsQueryOptions(), throwOnError: false });
  return query.data?.catalog.defaultWeightUnit ?? 'g';
}
